import router from './router';
import NProgress from 'nprogress';
import 'nprogress/nprogress.css'
import { Route } from 'vue-router'
import { Message } from 'element-ui';

import { UserModule } from '@/store/modules/user'
import { PermissionModule } from '@/store/modules/permission'

NProgress.configure({ showSpinner: false })

const whiteList = ['/login', '/auth-redirect']

router.beforeEach(async (to: Route, _: Route, next: any) => {
  // Start progress bar
  NProgress.start()
  // Determine whether the user has logged in
  if (UserModule.organizationName) {
    if (to.path === '/login') {
      next({ path: '/' })
    } else {
      // 查看角色 roles = [admin, property, maintence]
      console.log('权限', UserModule.roles)
      if (UserModule.roles.length === 0) {
        try {
          await UserModule.GetUserInfo()
          const roles = UserModule.roles
          PermissionModule.GenerateRoutes(roles)
          router.addRoutes(PermissionModule.dynamicRoutes)
          next({ ...to, replace: true })
        } catch (err) {
          // remove 登陆权限， 返回登陆页面
          UserModule.ResetOrganizationName()
          Message.error(err || 'Has Error')
          next(`/login?redirect=${to.path}`)
        }
      } else {
        next()
      }
    }
  } else {
    // Has no token
    if (whiteList.indexOf(to.path) !== -1) {
      // In the free login whitelist, go directly
      next()
    } else {
      // Other pages that do not have permission to access are redirected to the login page.
      next(`/login?redirect=${to.path}`)
    }
  }
})

router.afterEach((to: Route) => {
  NProgress.done()
})

